/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_DropdownInputs */



/**
* | output |
* | --- |
* | "Toggle Dropdown" |
*
* @param {Toggle_DropdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_dropdown = /** @type {((inputs?: Toggle_DropdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_DropdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer le Menu Deroulant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dropdown-Menü ein-/ausschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva menu a discesa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить выпадающее меню")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alternar menú desplegable")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换下拉菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドロップダウンを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्रॉपडाउन टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar menu suspenso")
	return /** @type {LocalizedString} */ ("Toggle Dropdown")
});